import { fetchApi } from '@/config/axiosSetting';
import {
  getInitialPreviousCorrectiveImagesParamsType,
  GetInitialPreviousCorrectiveImagesResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialPreviousCorrectiveImages/getInitialPreviousCorrectiveImagesQuery.type';

export const getInitialVisitPreviousCorrectiveImagesFunction = (
  params: getInitialPreviousCorrectiveImagesParamsType,
): Promise<GetInitialPreviousCorrectiveImagesResponseType> => {
  return fetchApi.get(
    `/initial/reports/${params.id}/images/corrective/request/list/`,
  );
};
